<template>
  <div class="recommend-list">
    <template v-if="loading">
      <div v-for="n in 3" :key="'sk-' + n">
        <div class="title flex items-center justify-between mt-[32px] mb-[16px]">
          <el-skeleton animated>
            <template #template>
              <el-skeleton-item variant="text" class="skeleton-title" />
            </template>
          </el-skeleton>
        </div>
        <div class="imageList">
          <div v-for="i in 3" :key="i" class="w-[33%] h-[80px] rounded-md overflow-hidden">
            <el-skeleton animated>
              <template #template>
                <el-skeleton-item variant="image" class="skeleton-img" />
              </template>
            </el-skeleton>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="item in list" :key="item.id">
        <div class="title flex items-center justify-between  mb-[16px]" v-if="item.materials.length > 0">
          <div class="text-ellipsis whitespace-nowrap overflow-hidden font-bold">{{ item.name }}</div>
          <div class="more cursor-pointer" @click="emit('more', item)"> 更多</div>
        </div>
        <div class="imageList mb-[32px]" v-if="item.materials.length > 0">
          <div v-for="(img, index) in item.materials.slice(0, 3)" :key="index"
            class="w-[33%] h-[90px] rounded-md overflow-hidden">
            <elementItem :template="img" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import elementItem from './elementItem.vue'
import { ElSkeleton, ElSkeletonItem } from 'element-plus'
const emit = defineEmits(['more', 'num'])
import { getMaterialsRecommendations } from '@/api/affairs'
import { onMounted, ref } from 'vue'
const props = defineProps<{ searchkwords: string }>()
onMounted(() => {
  getList()
})

const list = ref([])
const loading = ref(true)

const getList = () => {
  getMaterialsRecommendations({ page: 1, size: 100, type: 1, name: props.searchkwords }).then(res => {
    list.value = res.data.data.items
    emit('num', list.value)
  }).finally(() => {
    loading.value = false
  })
}
</script>

<style lang="scss" scoped>
.imageList {
  display: flex;
  gap: 4px;
  width: 100%;
}

.skeleton-title {
  width: 120px;
  height: 16px;
  border-radius: 6px;
}

.skeleton-img {
  width: 100%;
  height: 80px;
  border-radius: 8px;
}
</style>